import React, { useState, useEffect } from 'react'
import { ImEqualizer2 } from 'react-icons/im'
import { IoTrashSharp } from 'react-icons/io5'
import { useDispatch } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import NewFormWizard from '../../components/formWizard/NewFormWizard'
import Layout from '../../components/layouts/Layout'
import http, { URL_S3 } from '../../config/BaseUrl'
import PropFilter from '../events/components/Modal/PropFilter'

const Filters = (props) => {

    const [propFilterItem, setPropFilter] = useState([])
    const { id } = useParams()
    const history = useHistory()
    const dispatch = useDispatch()
    const [emailTemplateErr, setTemplateErr] = useState(false)
    const [loading, setLoading] = useState(false);

    const eventFilterEdit = history.location.state.eventFilterEdit

    useEffect(() => {
        if (eventFilterEdit) {
            let propsItem = []
            eventFilterEdit.forEach(item => {
                propsItem.push({ id: item.color_filter_id, image: item.filter_photo })
            })

            setPropFilter(propsItem)
        }
    }, [eventFilterEdit])


    const quotationLoader = {
        position: 'fixed',
        zIndex: '1000',
        background: 'rgba(255,255,255, 0.78)',
        width: '100%',
        height: '100vh',
        top: '0',
        left: '0',
        display: 'grid',
        alignItems: 'center',
        textAlign: 'center',
    }

    const handelFilter = async (e, data) => {
        e.preventDefault();
        setLoading(true)
        const submittedData = {
            option_filters: propFilterItem
        }
        await http.post(`/event/filter/update/${id}`, submittedData).then((res) => {
            if (res) {
                setLoading(false)
                history.push(`/show/event/${id}`, 'Information Updated.')
            }
        })

    }


    const setPropFilterByProps = (data) => {
        setPropFilter(data)
    }

    const removeProps = (id) => {
        let copyProps = [...propFilterItem]
        copyProps.splice(id, 1)
        setPropFilter(copyProps)

    }

    return (
        <Layout>
            <NewFormWizard />
            {/* <NewFormWizardChild /> */}
            <section className="mt-4">
                <div className="row justify-content-center">
                    <div className="col-md-10">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="text-center col-12 col-md-12">
                                        <div className="">
                                            <p className="mb-0 display-4 text-primary event-form-title">Filters</p>
                                            <p className="mb-0 text-secondary">Set your filters</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <form onSubmit={handelFilter}>
                    <div className="mt-2 mb-3 row justify-content-center">
                        <div className="col-md-10">
                            <div className="card">
                                <div className="card-body">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <ImEqualizer2 size={30} />
                                            <p className="mb-0 ml-2 font-size-16">Filter Library</p>
                                        </div>
                                        {
                                            emailTemplateErr &&
                                            <p className={`pt-2 mb-0 text-danger font-weight-bold text-right fade ${emailTemplateErr ? 'show' : 'hide'}`}>Choose any library</p>
                                        }
                                        <div className="float-right">
                                            <button type="button" className="btn btn-outline-primary" data-toggle="modal" data-target="#props-filter-modal">Select</button>

                                            <PropFilter setData={setPropFilterByProps} propFilterItem={propFilterItem} />
                                        </div>
                                    </div>
                                    <div className="prop__area">
                                        <div className="flex-wrap props-list d-flex justify-content-center">
                                            {
                                                propFilterItem.length > 0 ?
                                                    propFilterItem.map((propItem, index) => (
                                                        <div className="prop__item" key={`digital-props-index-${index}`}>
                                                            <img src={`${URL_S3}image/color_filter/${propItem.image}`} className="img-fluid" alt="props-data" />
                                                            <span className="remove-props" onClick={removeProps.bind(this, index)}>
                                                                <IoTrashSharp />
                                                            </span>
                                                        </div>
                                                    ))

                                                    :
                                                    <div className="prop__no__item">
                                                        <h4>No Filter Selected.</h4>
                                                    </div>
                                            }

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="my-4 row justify-content-center">
                        <div className="col-md-10">
                            <button type="submit" className="float-right px-5 btn btn-primary radius-10">
                                {loading ?
                                    <>
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Updating...
                                    </>
                                    : "Update"
                                }
                            </button>
                        </div>
                    </div>
                </form>
            </section>
        </Layout>
    )
}

export default Filters
